export const UI_OPEN_MOBILE_NAV = 'UI/OPEN_MOBILE_NAV'
export const UI_CLOSE_MOBILE_NAV = 'UI/CLOSE_MOBILE_NAV'

export const UI_DISABLE_FORCE_LEAVE = 'UI/DISABLE_FORCE_LEAVE'
export const UI_ENABLE_FORCE_LEAVE = 'UI/ENABLE_FORCE_LEAVE'

export const UI_ENABLE_MANY_INVITES_AT_ONCE = 'UI/ENABLE_MANY_INVITES_AT_ONCE'

export const UI_SCROLL_BODY_TO = 'UI/SCROLL_BODY_TO'

export const UI_DISABLE_ACTIVITY_ACTIONS_BUTTONS = 'UI/DISABLE_ACTIVITY_ACTIONS_BUTTONS'

export const UI_CHANGE_WINDOW_SIZES = 'UI/CHANGE_WINDOW_SIZES'
